import { useApiMutation, useApiQuery } from "../services/react-query";

export const useGetAllAvailableLanguages = (params) =>
  useApiQuery({
    queryOptions: {
      queryKey: ["languages", params],
    },
    fetchOptions: {
      url: "/languages",
      method: "GET",
      params,
    },
  });

export const useGetAllSelectableLanguages = () =>
  useApiQuery({
    queryOptions: {
      queryKey: ["selectableLanguages"],
    },
    fetchOptions: {
      url: "/languages/selectable",
      method: "GET",
    },
  });

export const useGetAllActiveLanguages = () =>
  useApiQuery({
    queryOptions: {
      queryKey: ["activeLanguages"],
    },
    fetchOptions: {
      url: "/languages/active",
      method: "GET",
    },
  });

export const useUpdateLanguage = () =>
  useApiMutation({
    mutationOptions: {
      mutationKey: ["updateLanguage"],
    },
    fetchOptions: {
      url: "/languages",
      method: "PATCH",
    },
    invalidateQueryKeys: [
      ["languages"],
      ["activeLanguages"],
      ["selectableLanguages"],
    ],
    successMessage: { title: "Language has been updated." },
  });

export const useDeleteLanguage = () =>
  useApiMutation({
    mutationOptions: { mutationKey: "useDeleteLanguage" },
    fetchOptions: {
      url: `/languages`,
      method: "DELETE",
    },
    invalidateQueryKeys: [
      ["languages"],
      ["activeLanguages"],
      ["selectableLanguages"],
    ],
    successMessage: { title: "Language has been deleted", color: "green" },
  });

export const useAddLanguage = () =>
  useApiMutation({
    mutationOptions: { mutationKey: "useAddLanguage" },
    fetchOptions: {
      url: `/languages`,
      method: "POST",
    },
    invalidateQueryKeys: [
      ["languages"],
      ["activeLanguages"],
      ["selectableLanguages"],
    ],
    successMessage: { title: "Language has been added", color: "green" },
  });
